export const VNTABS_SET_TAB_NAME_REQUIRED = 'VNTABS_SET_TAB_NAME_REQUIRED'
